// extracted by mini-css-extract-plugin
export default {"page":"Sms_page__tMc+y","text":"Sms_text__tJeKK","success":"Sms_success__X85FS"};